import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ListingsService } from '../services/listings.service';
import { map, catchError } from 'rxjs/operators';
import {CommunicationService} from "../services/communication.service";
import {ListingCategory} from "../classes/enums";
import {Commercial, Luxury} from "../app-config.constants";

@Injectable()
export class MapCityResolver implements Resolve<any> {

  constructor(private _router: Router, private _listingsService: ListingsService,
              private _communicationService: CommunicationService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> {
    const cityRegex =  /(\S+)-real-estate/;
    const province = route.url.length === 3 ? route.url[1].path : route.url[0].path;

    const listingCategory = this.getListingCategory(route.url[0].path);
    this._communicationService.setCurrentListingType(listingCategory);

    const cityMatches = cityRegex.exec(route.url.length === 3 ? route.url[2].path : route.url[1].path);
    let pageNumber = Number(route.queryParams.page) || 0; // For Pagination
    // We need to remember to decrement this value as pagination arrays start from 0
    if (pageNumber > 0) pageNumber--;

    if (cityMatches && cityMatches.length === 2) {

      const cityName = cityMatches[1];
      // Make a call to the listings to find the total hits before returning
      return this._listingsService.getListingsCount(false, province, cityName).pipe(
        map((hits) => {
          return {city: cityName, province: province, totalListings: hits, pageNumber: pageNumber};
        }),
        // FIXME: What should i do here
        catchError((err) => {
          return of({city: cityName, province: province, totalListings: 0, pageNumber: pageNumber});
        }));
    }
    else return of(null);
  }

  private getListingCategory(listingCategory: string) {
    switch(listingCategory) {
      case Luxury:
        return ListingCategory.LUXURY;
      case Commercial:
        return ListingCategory.COMMERCIAL;
      default:
        return this._communicationService.listings.currentShownListingType.getValue();
    }
  }
}
